import React from 'react';
import { Table, Spin } from 'antd';

import "./style.css";
const webConfig = require ('../../config.json');


export default class DynamicTable extends React.Component {

	// componentWillReceiveProps(nextProps) {
	// 	console.log(nextProps)
	// }

	setPageFilter = pagination => this.props.setPageFilter({
		page: pagination.current
	}, "reload")

	render () {
		return (
			<div>
				{(() => {
				switch (this.props.dataStatus) {
					case "reload":
					case "loaded":
						console.log(this.props.scrollx)
						return (
							<Table columns={this.props.column}
							dataSource={this.props.dataSource}
							rowKey={(record,index) => record.id?record.id:index+Math.random()}
							scroll= {this.props.scrollx?{x:this.props.scrollx}:{x:800}} 
							rowSelection={this.props.rowSelection}
							pagination={this.props.pagination}
							onChange={this.setPageFilter} />)
					case "error":
						return (
							<div style={{textAlign:'center', margin: '100px 0px'}}>
								{webConfig.httpFetchErrorInformation}
							</div>);
					case "loading":
					case "unload":
						return (
							<div style={{textAlign:'center', margin: '100px 0px'}}>
								<Spin size="large" />
							</div>);
					default :
						return null;
				}
				})()}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/frame/DynamicTable.js